import { MultiDatePicker } from 'components/MyDatePicker/MultiDatePicker';
import React, { useEffect, useState } from 'react';
// import { smartDateString } from 'utils/date';
// import Input from '../Input/Input';
// import Modal from '../Modal';

interface CalenderFieldProps {
  value: number | undefined;
  label?: string;
  withTime: boolean;
  onChange: (v: number | null) => void;
  min?: number;
  placeholder?: string;
}

export const CalendarField: React.FC<CalenderFieldProps> = ({
  value: currentValue,
  label,
  onChange,
  withTime,
  min,
  placeholder,
}) => {
  const [value, setValue] = useState(currentValue);
  // const [open, setOpen] = useState(false);
  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);
  return (
    <MultiDatePicker
      id={'datepickerModal'}
      setDate={(value) => {
        onChange(value ? Number(value) : value);
      }}
      placeholder={placeholder}
      label={label}
      value={value ?? undefined}
      hasTime={withTime}
      minDate={min}
    />
    /*    <span>
      <Input
        id={label || 'x'}
        label={label}
        type={'text'}
        readOnly={true}
        placeholder={placeholder}
        value={(value && smartDateString(value, withTime, true, true)) || ''}
        onClick={() => setOpen(true)}
      />
      <Modal isActive={open} title={label || ''} onClose={() => setOpen(false)}>
        <MultiDatePicker
          id={'datepickerModal'}
          setDate={(value) => {
            onChange(value ? Number(value) : value);
            setOpen(false);
          }}
          value={value ?? undefined}
          hasTime={withTime}
          minDate={min}
        />
      </Modal>
    </span>*/
  );
};
